import { Component } from '@angular/core';
import { Merchant } from 'src/app/common/models/merchant';
import { Operator } from 'src/app/common/models/operator';
import { Plan } from 'src/app/common/models/plan';
import { AdsSummary } from 'src/app/models/ads-summary'; 
import { AdsTraffic } from 'src/app/models/ads-traffic';
import { AdsService } from 'src/app/services/ads.service';
import { AuthService } from 'src/app/services/auth-service';
import { ProviderService } from 'src/app/services/provider.service';

@Component({
  selector: 'app-ads',
  templateUrl: './ads.component.html',
  styleUrls: ['./ads.component.css']
})
export class AdsComponent {

  merchants: Merchant[] = [];
  operator: string = '';
  merchant: string = '';

  selectedPlans: string[] = [];
  dateRange: Date[] = [new Date(),new Date()];

  adsSummaries: AdsSummary[] = [];
  adsTraffic: AdsTraffic[] = [];
  operatorDetailsArchive: [] = [];
 

  loading = false;
  archiveLoading = false;

  constructor(private adsService: AdsService
    , private providerService: ProviderService
    , private authService: AuthService
  ) { }


  operatorEvent(operator: Operator) {
    // this.loadMerchants(operator.id);
    this.operator = operator.id;
    this.merchant = '';
  }
  onSelectMerchant(merchant: Merchant | null) {
    this.merchant = merchant?.id ?? '';
  }
  loadMerchants(operator: string) {
    this.providerService.loadMerchants(operator).subscribe((merchants) => {
      this.merchants = merchants;
    });
  }
 

  onDateRangeChange(result: Date[]): void {
    this.dateRange = result;
  }

  onArchiveSearch() {
    if (!this.operator || this.dateRange.length <= 0) {
      return;
    }

    //Get new result
    this.loadAdsTraffic();
  }
  loadAdsSummaries(){
    this.adsService.getAdsSummaries(this.merchant,this.dateRange[0],this.dateRange[1]).subscribe((res) => {
      this.adsSummaries = res.data
    });

    this.onArchiveSearch();
  }
  loadAdsTraffic(){
    this.adsService.getAdsTraffics(this.operator,this.merchant,this.dateRange[0], this.dateRange[1]).subscribe({
      next:(res) => {
        this.adsTraffic = res.data
      },
       error: (err) => {
        console.log(err);
       }
    });
  }
}
